export default {
  clientAddressResults: [],
};
